/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { FaBookmark, FaRegBookmark } from 'react-icons/fa';
import { connect } from 'react-redux';
import { CreateBookmark, DeleteBookmark } from '../../store/User/userActions';
import BookmarkLoader from '../Loader/BookmarkLoader';

const Bookmark = ({
  user,
  bookmarks,
  bookmarkLoading,
  page,
  CreateBookmark,
  DeleteBookmark
}) => {

  const [isBookmark, setIsBookmark] = useState(false);
  const [bookmarkID, setBookmarkID] = useState(null);

  useEffect(() => {
    const isBook = page &&
      bookmarks &&
      bookmarks.length > 0 &&
      bookmarks.some((bookmark) => bookmark.page === page.slug);

    setIsBookmark(isBook);

    setBookmarkID(isBook ? bookmarks.filter((bookmark) => bookmark.page === page.slug)[0].id : null);
  }, [bookmarks, page]);

  const handleCreate = () => {
    CreateBookmark({
      pageId: page.slug,
      pageTitle: page.title,
      documentId: page.documentSlug,
    });
    setIsBookmark(true);
  };

  const handleDelete = () => {
    DeleteBookmark(bookmarkID);
    setIsBookmark(false);
  };

  return (
    user && user.restriction > 1 ? (
      <FaRegBookmark
        className="bookmark"
        style={{ cursor: 'not-allowed', opacity: '0.75' }}
        title="Upgrade your Subscription to access this feature."
      />
    ) : bookmarkLoading > 0 ? (
      <BookmarkLoader />
    ) : (
      isBookmark ? (
        <FaBookmark className="bookmark" color="white" title="Remove Bookmark" onClick={handleDelete} />
      ) : (
        <FaRegBookmark className="bookmark" color="white" title="Bookmark this Section" onClick={handleCreate} />
      )
    )
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  bookmarks: state.user.bookmarks,
  bookmarkLoading: state.user.bookmarkLoading,
  page: state.document.currentPage,
});

const mapDispatchToProps = { CreateBookmark, DeleteBookmark };

export default connect(mapStateToProps, mapDispatchToProps)(Bookmark);
